import { useDispatch } from 'react-redux'
import { Group } from '@wellesley/openapi'
import { setGroupData } from '@wellesley/host-remote/api/actions'
import { useEffect } from 'react'
import { useActiveGroupName } from '../../../hooks/useActiveGroupName'

export const useUpdateGroupState = (
  groupsList: Group[],
  defaultGroupName?: string,
) => {
  const dispatch = useDispatch()
  const activeGroupName = useActiveGroupName()
  const currentActiveGroupName = defaultGroupName || activeGroupName

  useEffect(() => {
    if (currentActiveGroupName) {
      const currentActiveGroup = groupsList.find(
        (group) => group.groupName === currentActiveGroupName,
      )

      if (currentActiveGroup) {
        dispatch(
          setGroupData([currentActiveGroup.groupName, currentActiveGroup]),
        )
      }
    }
  }, [currentActiveGroupName])
}
